/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react'; 

import { BuildProductLayout } from './component/ecomm-product-list.component';

import { IEcommProductListViewProps } from './component/components-interfaces-definition';

/**
 *
 * ProductListView component
 * @extends {React.PureComponent<IEcommProductListViewProps>}
 */
 export class EcommProductListView extends React.PureComponent<IEcommProductListViewProps> {
  public state: any = { hasMounted: false };

  public componentDidMount(): void {
    if (!this.state.hasMounted) {
      this.setState({ hasMounted: true });
    }
  }

  public render(): JSX.Element | null {
    if (!this.state.hasMounted) {
      return null;
    }
  
    const { resources, context, config, productsAvailability, productsList, productPriceList, simpleProductList, cart, telemetryContent, ModuleProps, ProductInfoContainerProps, MediaGalleryContainerProps, gridSettings } = this.props;

    return (
      <BuildProductLayout
        productList={productsList}
        simpleProductList={simpleProductList}
        productsAvailability={productsAvailability}
        productPriceList={productPriceList}
        cart={cart}
        telemetryContent={telemetryContent}
        resources= {resources}
        context={context}
        config={config}
        ModuleProps={ModuleProps}
        ProductInfoContainerProps={ProductInfoContainerProps}
        MediaGalleryContainerProps={MediaGalleryContainerProps}
        gridSettings={gridSettings}
        unavailableText={this.props.unavailableText}
      />
    );
  }
}

export default EcommProductListView;